module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_bird-98d3273b6409c9eccb29877e9b67afe7.png";